<div class="fix-action-row" data-qa="import-nzId-dialog">
  <div mat-dialog-content>

    <mat-horizontal-stepper
      linear="true"
      data-qa="stepper"
      #stepper>
      <mat-step [attr.data-qa]="'step-1'">
        <form>
          <ng-template matStepLabel>CSV Datei auswählen</ng-template>

          <div style="padding-bottom: 20px;">
            <p>
              Änderung der vorhandenen Netzzuordnung-IDs durch Mapping-Liste: Ändert sich
              Netzzuordnung-ID's durch den täglichen Import von Netzzuordnungen, können Erzeugungsanlagen
              ihre Referenz verlieren und erhalten den Status "ungültig". Die gelisteten Netzbetreiber im
              TNB-Portal sind gehalten, in regelmäßigen Abständen, ihre genannten Erzeugeranlagen
              hinsichtlich des Status zu kontrollieren und "ungültig" gewordene Erzeugeranlagen, durch
              Auswahl einer korrekten Netzzuordnung wieder in Status einer "gültigen" Referenz
              (Netzverknüpfung) zu überführen.

              Werden jedoch betrieblich bedingt massenhaft Netzzuordnung-ID's geändert, ist den
              Netzbetreibern eine zuvor beschriebene Korrektur nicht mehr zu zumuten und der Datenbestand
              der Erzeugeranlagen wird weitgehend betrieblich unbrauchbar.
            </p>
          </div>

          <redispatch-upload-file-form
            (fileEventEmitter)="handleFileChange($event)"
            allowedFileMimeType="text/csv"
            allowedFileTypeName="CSV">
          </redispatch-upload-file-form>

        </form>

      </mat-step>

      <mat-step>
        <form>
          <ng-template matStepLabel>Ergebnis überprüfen</ng-template>

          @if (backendFailure) {
            <div>
              <div class="backend-failure">
                <img class="backend-failure-image"
                  src="/assets/westnetz-icons/smileys/picto_smiley_sad.svg">
                </div>
                Es ist leider ein Fehler bei der Kommunikation mit dem Server aufgetreten und die
                Netzzuordnungs-Ids konnten nicht geprüft werden. Wir empfehlen, den Importvorgang noch
                einmal neu zu beginnen.
              </div>
            }

            @if (!backendFailure && !importReport && job()) {
              <div>
                <mat-progress-bar
                  class="progress-bar"
                  [color]="'primary'"
                  [mode]="'determinate'"
                  [value]="progress()">
              </mat-progress-bar>
              <table class="phase-table">
                <tr>
                  <td>
                    @if (job().phase <= NetzzuordnungIdImportJobPhase.PHASE_INITIAL) {
                      <mat-icon class="spinner"
                        >
                        check_box_outline_blank
                      </mat-icon>
                    }
                    @if (job().phase > NetzzuordnungIdImportJobPhase.PHASE_INITIAL) {
                      <mat-icon class="progress-done"
                        >
                        check_box
                      </mat-icon>
                    }
                  </td>
                  <td>
                    <span
                      [ngClass]="{'current-phase': job().phase === NetzzuordnungIdImportJobPhase.PHASE_INITIAL}">
                      Laden und Prüfen des CSV-Dokuments
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    @if (job().phase <= NetzzuordnungIdImportJobPhase.PHASE_PRE_VALIDATE) {
                      <mat-icon class="spinner"
                        >
                        check_box_outline_blank
                      </mat-icon>
                    }
                    @if (job().phase > NetzzuordnungIdImportJobPhase.PHASE_PRE_VALIDATE) {
                      <mat-icon class="progress-done"
                        >
                        check_box
                      </mat-icon>
                    }
                  </td>
                  <td>
                    CSV Validierung
                  </td>
                </tr>
                <tr>
                  <td>
                    @if (job().phase < NetzzuordnungIdImportJobPhase.PHASE_VALIDATED) {
                      <mat-icon class="spinner"
                        >
                        check_box_outline_blank
                      </mat-icon>
                    }
                    @if (job().finished) {
                      <mat-icon class="progress-done"
                        >
                        check_box
                      </mat-icon>
                    }
                  </td>
                  <td>
                    <span
                      [ngClass]="{'current-phase': job().phase === NetzzuordnungIdImportJobPhase.PHASE_VALIDATED}">
                      Bereite Prüfbericht vor
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          }

          @if (importReport) {
            <redispatch-importreport-display
              [netzzuordnungIdImportReport]="importReport"
              [id]="PRINT_ELEMENT_ID">
            </redispatch-importreport-display>
          }
        </form>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Fertig</ng-template>
        @if (!importReport && job()) {
          @if (!backendFailure) {
            <mat-progress-bar
              class="progress-bar"
              [color]="'primary'"
              [mode]="'determinate'"
              [value]="progress()">
            </mat-progress-bar>
            <table class="phase-table">
              <tr>
                <td>
                  @if (job().phase <= NetzzuordnungIdImportJobPhase.PHASE_INITIAL) {
                    <mat-icon class="spinner"
                      >
                      check_box_outline_blank
                    </mat-icon>
                  }
                  @if (job().phase > NetzzuordnungIdImportJobPhase.PHASE_INITIAL) {
                    <mat-icon class="progress-done"
                      >
                      check_box
                    </mat-icon>
                  }
                </td>
                <td>
                  <span
                    [ngClass]="{'current-phase': job().phase === NetzzuordnungIdImportJobPhase.PHASE_INITIAL}">
                    Laden und Prüfen des CSV-Dokuments
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  @if (job().phase <= NetzzuordnungIdImportJobPhase.PHASE_PERSIST) {
                    <mat-icon class="spinner"
                      >
                      check_box_outline_blank
                    </mat-icon>
                  }
                  @if (job().phase > NetzzuordnungIdImportJobPhase.PHASE_PERSIST) {
                    <mat-icon class="progress-done"
                      >
                      check_box
                    </mat-icon>
                  }
                </td>
                <td>
                  <span
                    [ngClass]="{'current-phase': job().phase === NetzzuordnungIdImportJobPhase.PHASE_PERSIST}">
                    Übernahme in Datenbank
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  @if (job().phase < NetzzuordnungIdImportJobPhase.PHASE_FINALIZE) {
                    <mat-icon class="spinner"
                      >
                      check_box_outline_blank
                    </mat-icon>
                  }
                  @if (job().finished) {
                    <mat-icon class="progress-done">check_box</mat-icon>
                  }
                </td>
                <td>
                  <span
                    [ngClass]="{'current-phase': job().phase === NetzzuordnungIdImportJobPhase.PHASE_FINALIZE}">
                    Importvorgang abschließen
                  </span>
                </td>
              </tr>
            </table>
          }
          @if (backendFailure) {
            <div class="backend-failure">
              <img class="backend-failure-image"
                src="/assets/westnetz-icons/smileys/picto_smiley_sad.svg">
              </div>
              Es ist leider ein Fehler bei der Kommunikation mit dem Server aufgetreten und die
              Netzzuordnungs-Ids wurden möglicherweise nicht importiert. Wir empfehlen, den Importvorgang
              noch einmal neu zu beginnen.
            }
          }
          @if (importReport && job()) {
            @if (importReport.success) {
              <div>
                <h2 data-qa="import-nzId-success">Die Netzzuordnungs-Ids wurden erfolgreich importiert</h2>
              </div>
            }
            @if (!importReport.success) {
              <div>
                <h2>Es ist leider ein Fehler beim Import aufgetreten. Sollte der Import bei einem erneuten
                  Versuch wiederholt scheitern, schicken Sie das CSV-Dokument zur Prüfung bitte an Ihren
                  Kundenbetreuer.
                </h2>
              </div>
            }
          }
        </mat-step>
      </mat-horizontal-stepper>
    </div>

    <div class="spacer"></div>

    <div mat-dialog-actions class="wizard-footer">
      @if (loading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }

      <div class="wizard-footer-right">
        @if (stepper.selectedIndex === 1 && containsLogs()) {
          <button matButton="outlined"
                  aria-label="Öffnet den Druckdialog um z.B. den Druckbereich als PDF zu speichern"
                  matTooltip="Öffnet den Druckdialog um z.B. den Druckbereich als PDF zu speichern"
                  matTooltipPosition="left"
                  color="primary"
                  data-qa="print-button"
                  (click)="print()"
          >
          Fehlermeldungen drucken
        </button>
      }

      @if (stepper.selectedIndex !== 2) {
        <button
          matButton="outlined"
          data-qa="cancel-button"
          (click)="close()">
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
          Abbrechen
        </button>
      }

      @if (stepper.selectedIndex === 0 && !!selectedFile) {
        <button
          class="confirm-button"
          matButton="filled"
          data-qa="upload-and-check-button"
          (click)="upload(true)">
            <mat-icon>cloud_upload</mat-icon>
          Datei hochladen und prüfen
        </button>
      }

      @if (stepper.selectedIndex === 1) {
        <button
          class="confirm-button"
          matButton="filled"
          data-qa="start-import-button"
          [disabled]="!importReport?.success"
          (click)="upload(false)">
            <mat-icon>cloud_upload</mat-icon>
          Import starten
        </button>
      }

      @if (stepper.selectedIndex === 2) {
        <button
          class="confirm-button"
          matButton="filled"
          data-qa="close-button"
          (click)="close()">
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
            Schließen
        </button>
      }

    </div>
  </div>
</div>
